<template>

    <CCard>
        <CCardHeader>
            Настройки рекламного места
            <RestaurantTableOrderBadge />
        </CCardHeader>
        <RestaurantsTabLinks />

        <CCardBody>
            <div class="overflow-hidden border border-gray-300 rounded-md pl-2 pr-2 pt-2">
                <CRow v-if="aplaceSettings.aplace_logo">
                    <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="aplaceLogoUrl"
                                class="m2"
                                width="40" />
                        </CCol>
                    </CRow>
                    <CInputFile
                        ref="picture"
                        label="Логотип"
                        horizontal
                        @change="selectAplaceLogo" />
                    <CRow v-if="aplaceSettings.aplace_logo_name">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="aplaceLogoNameUrl"
                                class="m2"
                                width="120" />
                        </CCol>
                    </CRow>
                    <CInputFile
                        ref="picture"
                        label="Логотип на место названия"
                        horizontal
                        @change="selectAplaceLogoName" />

                    <CInput v-model="aplaceSettings.aplace_description" label="Короткое описание" />
                    <CTextarea v-model="aplaceSettings.aplace_css" label="CSS свойства" />
            </div>
        </CCardBody>

        <CCardFooter>
            <CButton
                color="primary"
                class="mr-3"
                @click="save"
            >Сохранить</CButton>

            <CButton
            variant="outline"
            color="danger"
            class="mr-3"
            @click="remove"
            >Очистить (Удалить)</CButton>
        </CCardFooter>


        <CElementCover
            v-if="isPending"
            :opacity="0.8"
        >
            <div class="flex items-center">
                <CSpinner size="sm" />
                <p class="ml-2 text-xl">Сохранение... </p>
            </div>
        </CElementCover>
            
    </CCard>

</template>

<script>    
    import Vue from 'vue';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';

    export default {

        name: 'RestaurantAPlace',

        components: {
            RestaurantsTabLinks,
        },
  
        data () {
            return {
                aplaceSettings: {},
                isPending: false
            }
        },

        computed: {
            aplaceLogoUrl() {
                if (this.aplaceSettings.aplace_logo) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.aplaceSettings.aplace_logo;
                }
                return '';
            },
            aplaceLogoNameUrl() {
                if (this.aplaceSettings.aplace_logo_name) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.aplaceSettings.aplace_logo_name;
                }
                return '';
            },
        },

        async mounted() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                try {
                    const id = this.$route.params.id;
                    const aplSettings = await Vue.axios.get('/restaurants/' + id);
                    this.aplaceSettings = aplSettings.data;
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            selectAplaceLogo(FileList) {
                this.selectedAplaceLogo = FileList[0];
            },
            selectAplaceLogoName(FileList) {
                this.selectedAplaceLogoName = FileList[0];
            },

           async remove () {
               this.aplaceSettings.aplace_logo = null
               this.aplaceSettings.aplace_logo_name = null
               this.aplaceSettings.aplace_description = null
               this.aplaceSettings.aplace_css = null
                if(this.aplaceSettings.id) {
                    await Vue.axios.post('/restaurants/update/' + this.$route.params.id, this.aplaceSettings);
                } 
            },

            async save() {
                this.isPending = true;
            
                try {
                    let formData = new FormData();

                    if (this.selectedAplaceLogo) {
                        formData = new FormData();
                        formData.append('file', this.selectedAplaceLogo);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.aplaceSettings.aplace_logo = uploadPicture.data.filename;
                    }

                    if (this.selectedAplaceLogoName) {
                        formData = new FormData();
                        formData.append('file', this.selectedAplaceLogoName);
                        const uploadPicture = await Vue.axios.post('/files/upload', formData);
                        this.aplaceSettings.aplace_logo_name = uploadPicture.data.filename;
                    }
                    if(this.aplaceSettings.id) {
                        await Vue.axios.post('/restaurants/update/' + this.$route.params.id, this.aplaceSettings);
                    } 
                    await this.fetch();                          
                } catch (error) {
                    console.log(error, 'e');
                    this.$root.$emit('showError', 'Не удалось сохранить');
                }

                this.isPending = false;
            },
        }
    }
</script>
